import { render } from "./ProjectParticipantHistoryPartListWidget.vue?vue&type=template&id=0f9de371&ts=true"
import script from "./ProjectParticipantHistoryPartListWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectParticipantHistoryPartListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__